import { Modal } from "react-bootstrap";
import styles from "./Categorias.module.scss";

const ETIQUETA_ESTADO = {
  activado: "Activado",
  vinculado: "Vinculado",
  sin_contacto: "Sin contacto",
};

/**
 * Lista de nombres de empresa de un tramo de cobertura (categoría × estado) — 10.135, modal
 * simple con scroll interno, sin edición (solo lectura).
 */
export const ListaEmpresasModal = ({ show, onHide, categoriaLabel, estado, nombres }) => (
  <Modal show={show} onHide={onHide} centered>
    <Modal.Header closeButton>
      <Modal.Title>
        {categoriaLabel} — {ETIQUETA_ESTADO[estado] || estado}
      </Modal.Title>
    </Modal.Header>
    <Modal.Body className={styles.listaEmpresasBody}>
      {nombres.length === 0 ? (
        <p className="text-muted mb-0">Sin empresas en este grupo.</p>
      ) : (
        <ul className={styles.listaEmpresas}>
          {nombres.map((nombre) => (
            <li key={nombre}>{nombre}</li>
          ))}
        </ul>
      )}
    </Modal.Body>
  </Modal>
);
